import { render, staticRenderFns } from "./TugBoatDeparture.vue?vue&type=template&id=00c38e82&"
import script from "./TugBoatDeparture.vue?vue&type=script&lang=js&"
export * from "./TugBoatDeparture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports